import axios from "axios";

import { getRole } from '@/utils/router.js'

class Orders {
    constructor() {
        this.url = `/api/v1/orders`;
    }

    getUrlWithRole() {
        let url = '/api/v1/orders';
        const role = getRole();

        if(role === 'client') {
            url = '/api/v1/client/orders';
        }

        return url
    }

    getList(filter = {}) {
        return axios.get(this.getUrlWithRole(), {
            params: filter
        });
    }
}

export default Orders;